<template>
    <div>
        <div class="container error-another-login" v-if="errorMessage == 1">
            Another person is logging-in into your account at a different place. Please contact WikiAllergies
            immediately if
            you think someone is fraudulently trying to use your account. Please log in at WikiAllergies.com again and
            change your user name and password if you think your account has been compromised.
            <br/><br/>
            Report to WikiAllergies <a href="javascript:void(0)">HERE</a>.
        </div>
        <div class="content container">
            <div class="row">
                <div class="col-xs-8">
                    <img src="img/immuintro.png" alt="WikiAllergies Immunotherapy">
                </div>
                <div class="col-xs-4 maincontent">
                    <div class="editproviewport blockcont">
                        <h2 class="smalltitle">Sign in</h2>
                        <div>Please sign-in again using your WikiAllergies account ID and password.</div>
                        <form ref="form" @submit.prevent="login">
                            <input style="display:none" type="text" name="fakeusernameremembered"/>
                            <input style="display:none" type="password" name="fakepasswordremembered"/>
                            <div class="prolabel fullw note">Email</div>
                            <div class="profield fullw"><input type="text" ref="email" v-model="input.email"
                                                               autocomplete="off"></div>
                            <div class="prolabel fullw note">Account Password</div>
                            <div class="profield fullw"><input type="password" ref="password" v-model="input.password"
                                                               autocomplete="off"></div>
                            <div class="prolabel fullw"><span style="color: red" v-if="input.msg">{{input.msg}}</span>
                            </div>
                            <div class="profield fullw"><a href="https://wikiallergies.com/forgot-password">&raquo;
                                Forgot your password?</a></div>
                            <div class="prosubmit fullw">
                                <button type="submit" class="btn" value="Sign in"><i class="fas fa-spinner fa-spin"
                                                                                     v-if="processing"></i> Sign in
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <i class="fas fa-spinner fa-spin" style="position: absolute; left: -500px; top: -500px"></i>
    </div>
</template>

<script>
import axios from './../client'

export default {
  name: 'Login',
  data () {
    return {
      input: {
        email: '',
        password: '',
        msg: ''
      },
      processing: false,
      errorMessage: 0
    }
  },
  methods: {
    login () {
      if (this.input.email !== '' && this.input.password !== '') {
        if (this.processing) return
        this.processing = true
        axios.post(`/login`, { email: this.input.email, password: this.input.password }).then(response => {
          this.processing = false
          let body = response.data
          if (body.s === 200) {
            this.$store.commit('setAuthenticated', true)
            this.$store.commit('setSettingMode', body.data.user.settingMode)
            this.$store.commit('setUser', body.data.user)

            if (window.innerWidth >= 1336) {
              this.$store.commit('setFullScreen', true)
              document.body.className = 'fullscreen'
            }
            if (this.$store.state.user.role !== 'RegularUser') {
              this.$router.replace({ name: 'home' })
            } else {
              this.$router.replace({ name: 'setting' })
            }
          } else {
            this.input.msg = response.data.msg
          }
        }).catch(e => {
          console.log('Error page login', e.stack)
          this.processing = false
          this.input.msg = e.message
        })
      } else {
        this.input.msg = 'An email and password must be present'
      }
    }
  },
  created () {
    this.errorMessage = this.$route.query.type
    if (this.$store.state.user.email) {
      this.input.email = this.$store.state.user.email
    }
    if (this.$route.query && this.$route.query.email) {
      this.input.email = this.$route.query.email
    }
    this.$store.commit('setOpenModalLogin', false)
    this.$store.commit('setAuthenticated', false)
  },
  mounted () {
    if (this.input.email) {
      this.$refs.password.focus()
    } else {
      this.$refs.email.focus()
    }
  }
}
</script>
<style scoped>
    .error-another-login {
        color: gray;
        margin-bottom: 15px;
        font-size: 20px;
    }
</style>
